import { atomWithStorage, createJSONStorage } from 'jotai/utils'
import { store } from '.'

export const THEMES = ['light', 'dark'] as const
export type Theme = (typeof THEMES)[number]

export const DEFAULT_THEME: Theme = 'light'

const THEME_STORAGE_KEY = 'ui-theme'

const isTheme = (value: unknown): value is Theme => THEMES.includes(value as Theme)

// Anything stored that this build does not offer (the retired `system` option, a hand-edited value) reads as the default.
const jsonStorage = createJSONStorage<Theme>(() => localStorage)
const themeStorage: typeof jsonStorage = {
  ...jsonStorage,
  getItem: (key, initialValue) => {
    const stored = jsonStorage.getItem(key, initialValue)
    return isTheme(stored) ? stored : initialValue
  },
}

export const themeAtom = atomWithStorage<Theme>(THEME_STORAGE_KEY, DEFAULT_THEME, themeStorage, {
  getOnInit: true,
})

export const getTheme = () => store.get(themeAtom)
export const setTheme = (theme: Theme) => store.set(themeAtom, theme)
